import { IInstanceComponentBase, InstanceComponentBase } from "../../shared/instanceComponentBase";
import { AttributeEnums } from "../../shared/utilities/enums/attributeEnums";
import { CustomEventEnums } from "../../shared/utilities/enums/customEventEnums";
import { HelperUtils } from "../../shared/utilities/helperUtils";
import { IReviewsAggregate, IReviewsSummary } from "./reviewsAggregate";
import { IReviewWidgetPagerRatingsFilterOption, ReviewWidgetPagerRatingsFilterOption } from "./reviewWidgetPagerRatingsFilterOption";
import { IReviewWidgetSummaryFilterComponentBase, ReviewWidgetSummaryFilterComponentBase } from "./reviewWidgetSummaryFilterComponentBase";

export interface IReviewWidgetPagerRatingsFilter extends IReviewWidgetSummaryFilterComponentBase {
    selectedRating: number;
    update:(selectedRating:number, reviewsSummary: IReviewsSummary) => void;
}

export class ReviewWidgetPagerRatingsFilter extends ReviewWidgetSummaryFilterComponentBase implements IReviewWidgetPagerRatingsFilter {
    public selectedRating: number;

    constructor(public htmlElement: HTMLElement) {
        super(htmlElement);
    }

    componentOptionFactory(currentHtmlElement: HTMLElement): ReviewWidgetPagerRatingsFilterOption{

        let currentRating = currentHtmlElement.getAttribute(AttributeEnums.ReviewWidgetRatingsOption.ratingsOptionRating);
        let isDisabled = this.getStateForIsDisabledFilterOption(+currentRating);
        let isSelected = this.getStateForIsSelectedFilterOption(+currentRating);
        let optionElement: ReviewWidgetPagerRatingsFilterOption = new ReviewWidgetPagerRatingsFilterOption(currentHtmlElement, isDisabled, isSelected);
        return optionElement;
    }

    setIReviewWidgetPagerRatingsFilterOption(ratingsFilterOption: IReviewWidgetPagerRatingsFilterOption):void {
        ratingsFilterOption.isDisabled = this.getStateForIsDisabledFilterOption(ratingsFilterOption.rating);
        ratingsFilterOption.isSelected = this.getStateForIsSelectedFilterOption(ratingsFilterOption.rating);
        ratingsFilterOption.update(ratingsFilterOption.isSelected, ratingsFilterOption.isDisabled);
    }

    updateIReviewWidgetPagerRatingsFilterOptions():void{
        this.componentOptions.forEach(ratingsFilterOption => {
            this.setIReviewWidgetPagerRatingsFilterOption(ratingsFilterOption as IReviewWidgetPagerRatingsFilterOption);
        }); 
    }

    updateState(selectedRating: number, reviewsSummary: IReviewsSummary):void{
        this.updateSelectedRating(selectedRating);
    }

    updateDisplay():void{
      this.updateIReviewWidgetPagerRatingsFilterOptions();
    }

    update(selectedRating:number, reviewsSummary: IReviewsSummary):void{
        this.updateBase(reviewsSummary);
        this.updateState(selectedRating, reviewsSummary);
        this.updateDisplay();
    }
}